import React from 'react';
import styles from './gameCarouselSkeleton.module.scss';
import Skeleton from 'components/skeleton/Skeleton';

interface GameCarouselSkeletonProps {
  cardsCount?: number;
}

const GameCarouselSkeleton: React.FC<GameCarouselSkeletonProps> = ({ cardsCount = 8 }) => {
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.header}>
        <div className={styles.title}>
          <Skeleton className={styles.skeletonTitle} variant="rectangular" />
        </div>
      </div>
      <div className={styles.track}>
        {Array.from({ length: cardsCount }).map((_, index) => (
          <Skeleton key={index} className={styles.skeletonCard} variant="rectangular" />
        ))}
      </div>
    </div>
  );
};

export default GameCarouselSkeleton;
